export interface MetaModel {
    id: string | number;
    attributes: MetaAttributes;
}

export interface MetaAttributes {
    key: string;
    value: string | null;
    valueLong: string | null;
}

export const DEFAULT_META_VALUES = [
    {
        "id": 2,
        "attributes": {
            "key": "CHAINS",
            "value": "13",
            "valueLong": null,
            "createdAt": "2025-05-03T12:03:41.495Z",
            "updatedAt": "2025-05-03T12:03:43.771Z",
            "publishedAt": "2025-05-03T12:03:43.759Z"
        }
    },
    {
        "id": 1,
        "attributes": {
            "key": "HOLDERS",
            "value": "921K",
            "valueLong": null,
            "createdAt": "2025-05-03T12:00:37.928Z",
            "updatedAt": "2025-05-03T13:28:51.949Z",
            "publishedAt": "2025-05-03T12:03:54.654Z"
        }
    },
    {
        "id": 3,
        "attributes": {
            "key": "ABOUT",
            "value": null,
            "valueLong": "BONK is the social layer and community meme coin of Solana with deep integrations as a utility token across a wide base of application and protocols within the web3 ecosystem. As the true community coin of web3, BONK's utility comes in the form of its strong community and thriving ecosystem of integrations.",
            "createdAt": "2025-05-03T17:30:31.031Z",
            "updatedAt": "2025-05-03T17:30:59.831Z",
            "publishedAt": "2025-05-03T17:30:59.822Z"
        }
    }
];